import { feasibilityActions, translate } from '../../services';
import { messageDispatcher } from './messageDispatcher';
import ReactHtmlParser from "react-html-parser";

const addMessage = (dispatch, message, insertions) => {
    messageDispatcher(dispatch).addMessage({ timeout: 0, messageType: 'warning', messageText: translate(ReactHtmlParser(message), insertions) });
};

export const feasibilityDispatcher = dispatch => ({
    fetchFeasibilityValues: () => dispatch({ type: feasibilityActions.LOAD, data: { payload: [], fieldNo: 'Electrical' } }),
    assignITCTValue: (payload, fieldNo) => {
        return dispatch({ type: feasibilityActions.VALIDATE, data: { payload: payload } })
            .then((data) => {
                if (data?.status === "Ok" || data?.status === "Warning") {
                    fieldNo && dispatch({ type: feasibilityActions.LOAD, data: { payload: payload, fieldNo: fieldNo } })
                } 
                if(data?.message) {
                    addMessage(dispatch, data?.message);
                }
            })
    },
    calculatePhysibility: (payload, fieldNo) => {
        return dispatch({ type: feasibilityActions.LOAD, data: {  payload: payload, fieldNo: fieldNo } })
            .then((data) => {
                if (JSON.parse(data?.data.data).resultId) {
                    return dispatch({ type: feasibilityActions.GETRESULT, resultId: JSON.parse(data?.data.data).resultId })
                } else {
                    addMessage(dispatch, data?.message || "Validation Failed!");
                }
            })
    },
    getConfiguratorId: (resultId) => {
        return dispatch({type: feasibilityActions.GETCONFIGURATORID, resultId: resultId})
    },
    resetFeasibilityConfigurator: () => {return dispatch({type: feasibilityActions.RESET, data: {}})}
});
